<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>计件记录列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">计件中</el-radio-button>
                    <el-radio-button label="1">已结束</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

        </div>

        <el-table :data="reckonNumberList" style="width: 100%" ref="patrolPointTable" highlight-current-row>

            <el-table-column type="index" width="20" fixed>
            </el-table-column>

            <el-table-column prop="checkStatus" label="审批状态" min-width="5%" align="center">
            </el-table-column>
            <el-table-column prop="status" label="计件状态" min-width="10%">
            </el-table-column>
            <el-table-column prop="employeeName" label="计件人" min-width="10%">
            </el-table-column>
            <el-table-column prop="startTime" label="开始时间" min-width="11%">
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间" min-width="11%">
            </el-table-column>

            <el-table-column prop="equipmentCode" label="设备编号" min-width="10%">
            </el-table-column>

            <el-table-column prop="orderCode" label="订单编号" min-width="10%">
            </el-table-column>

            <el-table-column prop="productProcess" label="产品" min-width="13%">
            </el-table-column>

            <el-table-column prop="quantity" label="计件数量" min-width="10%" align="center">
            </el-table-column>
            <el-table-column prop="qualifiedQuantity" label="合格数" min-width="11%" align="center">
            </el-table-column>
            <el-table-column prop="unqualifiedQuantity" label="不合格数" min-width="9%" align="center">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button @click="checkClick(scope.row)" type="success" round size="small"
                        :disabled="scope.row.checkStatus == '' ? false : true">
                        审批
                    </el-button>
                    <!-- <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button> -->
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[5, 10, 15, 20]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-drawer title="巡检详情" :visible.sync="drawerVisible" size="40%" style="text-align: left;">
            <div style="padding: 0 10px;">
                <el-descriptions>
                    <el-descriptions-item label="巡检点名称">{{ drawer.patrolPointName }}</el-descriptions-item>
                    <el-descriptions-item label="巡检人">{{ drawer.maker }}</el-descriptions-item>
                    <el-descriptions-item label="巡检时间">{{ drawer.createdTime }}</el-descriptions-item>

                    <el-descriptions-item label="巡检说明">{{ drawer.remark }}</el-descriptions-item>
                    <el-descriptions-item label=""></el-descriptions-item>
                    <el-descriptions-item label=""></el-descriptions-item>

                    <el-descriptions-item label="上传照片">
                        <img v-for="item in drawer.imgUrlList" :key="item" :src="'https://' + imagePath + item"
                            class="avatar">
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div style="background-color: #f5f7fa;color:green;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;">
                巡检项目
            </div>

            <div v-for="item in inspectionItemList" :key="item.id" style="display:flex">
                <p style="text-align: left;width:80%;margin-left: 10px;">{{ item.inspectionName }}</p>

                <div style="display:inline-block;line-height: 40px;margin: 5px 0;font-weight: bold;color: green;">
                    {{ item.status == 1 ? '正常' : '异常' }}
                </div>
            </div>

            <div style="margin-top: 10px;">
                <span style="color: green;">●</span>
                巡检结果 <el-tag type="success">{{ drawer.status }}</el-tag>
            </div>

        </el-drawer>

    </div>
</template>

<script>
export default {
    name: "ReckonNumberRecord",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),

            reckonNumberList: [],

            drawerVisible: false,

            statusSearch: 0,

            drawer: {
                id: '',
                imgUrlList: [],
                imgFile: null,
                patrolPointCode: '',
                patrolPointName: '',
                maker: '',
                createdTime: '',
                remark: '',
                status: ''
            },

            selectedEquipRow: {},

            equipmentId: '',
            equipmentCode: '',
            processId: '',

            productProcessThree: '',
            processQueueThree: null,

            inspectionPicOne: '',
            remark: '',
            processInspection: {},

            inspectionItemList: [],

            pageIndex: 0,
            pageNum: 5,
            total: 0,
            pageCount: 0,
        }
    },
    methods: {
        searchByStatus(val) {
            this.statusSearch = val
            this.pageIndex = 0
            //console.log('bbb')
            //console.log(val)
            this.getAllReckonNumberRecord()
        },
        getAllReckonNumberRecord() {

            this.$axios({
                method: "post",
                url: "/shiro/reckon/number/getAll",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId,
                    status: this.statusSearch,
                    checkStatus: -1
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.reckonNumberList = data.data
                this.total = this.reckonNumberList[0].total
                
                for (let i in this.reckonNumberList) {

                    this.reckonNumberList[i].startTime = this.reckonNumberList[i].startTime == null ? '-' : this.$moment(this.reckonNumberList[i].startTime).format("YYYY-MM-DD HH:mm")

                    this.reckonNumberList[i].endTime = this.reckonNumberList[i].endTime == null ? '-' : this.$moment(this.reckonNumberList[i].endTime).format("YYYY-MM-DD HH:mm")

                    if (this.reckonNumberList[i].status == 0) {
                        this.reckonNumberList[i].status = '计件中'
                    } else {
                        this.reckonNumberList[i].status = '已结束'
                    }

                    if (this.reckonNumberList[i].checkStatus == 0 || this.reckonNumberList[i].checkStatus == null) {
                        this.reckonNumberList[i].checkStatus = ''
                    } else {
                        this.reckonNumberList[i].checkStatus = '✅'
                    }

                }

            })
        },
        checkReportWork(row) {
            this.$axios({
                method: "post",
                url: "/shiro/report/work/modify",
                data: {
                    reckonNumberId: row.id,
                    checkStatus: 1,
                    approver: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })
            })
        },
        checkClick(row) {

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.checkReportWork(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        pageClick(currentPage) {
            this.reckonNumberList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAllReckonNumberRecord()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllReckonNumberRecord()
        },
    },
    mounted() {
        this.setDefaultPath('/reckonNumberRecord')

        this.getAllReckonNumberRecord()
    },
    updated() {

    }
}
</script>

<style>
.avatar-uploader {
    width: 142px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-descriptions-item__content {
    color: green;
    font-weight: bold;
}

.el-pagination__total {
    color: green;
}
</style>